import * as ActionTypes from './actionTypes';

export function setLastEntryId(EntryId){
    return {
        type: ActionTypes.SET_LAST_ENTRYID,
        payload: { EntryId },
    };
}


// WEBPACK FOOTER //
// ./components/response-handlers/form-interaction/actions/actions.js